import { render } from "./TestModal.vue?vue&type=template&id=64fff48b&scoped=true"
import script from "./TestModal.vue?vue&type=script&lang=js"
export * from "./TestModal.vue?vue&type=script&lang=js"

import "../../assets/styles/test-modal.css?vue&type=style&index=0&id=64fff48b&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64fff48b"]])

export default __exports__